import React, {Suspense} from 'react';
import {useTranslation} from "react-i18next";
import {ConfigApi} from "../../../../services/Api/types";

interface Props {
    config: ConfigApi;
    withoutMap?: boolean;
}

const Map = React.lazy(() => import('../../../Map/Map'));

const FooterMap = ({withoutMap, config}: Props) => {
    const {t} = useTranslation();
    const center: [number, number] | undefined = config?.coordinates ? [Number(config.coordinates.latitude), Number(config.coordinates.longitude)] : undefined;
    const zoom = 15;

    return (
        center && !withoutMap ? (
            <div className={"col"}>
                <div className={"footer-map"}>
                    <Suspense fallback={
                        <div>
                            {t("modules.footer.field.map_loading.title")}
                        </div>
                    }>
                        <Map center={center} zoom={zoom} useResizer/>
                    </Suspense>
                </div>
            </div>
        ) : <></>
    )
}

export default FooterMap;